import React from 'react';
import {useTheme} from "@material-ui/core";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import {useTranslation} from "react-i18next";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import styled from "@material-ui/core/styles/styled";
import {connect} from "react-redux";

const StyledDeletedPrice = styled(Box)({
    textDecoration: 'line-through',
    color: 'grey',
    fontSize: '18px',
    paddingLeft: 5
})

const PayPage = ({daysLeft = '999'}) => {
    const theme = useTheme()
    const isDesktop = useMediaQuery(theme.breakpoints.up('lg'))
    const {t} = useTranslation()

    return <Box width={isDesktop ? theme.maxContentWidth : '100%'} flex={1} display={'flex'} alignItems={'center'} p={2}
                boxSizing={'border-box'}
                overflow={'hidden'}
                flexDirection={'column'}>
        <Typography variant={'h3'} color={'primary'} gutterBottom={true}>{`${daysLeft} ${t('days-left')}`}</Typography>
        <Typography variant={'h2'} color={'primary'} gutterBottom={true}>{t('add-more-days')}</Typography>
        <PayingOption title={t('month')} amount={'10₪'} orgAmount={'49₪'}
                      link={'https://payboxapp.page.link/EmWaYRd4CeDZhu61A'}/>
        <PayingOption title={t('3months')} amount={'25₪'} orgAmount={'129₪'}
                      link={'https://payboxapp.page.link/shMJb9Nf7V8xd8j68'}/>
        <PayingOption title={t('6months')} amount={'45₪'} orgAmount={'239₪'}
                      link={'https://payboxapp.page.link/s6KeEmHMhGgycRew6'}/>
    </Box>
}
const mapStateToProps = (state) => ({
    daysLeft: state.general?.supplier?.daysLeft
})

export default connect(mapStateToProps)(PayPage);

const PayingOption = ({amount, title, link, orgAmount}) => {
    return <Box component={'a'} target={'_blank'} display={'flex'} alignItems={'center'}
                justifyContent={'space-between'} href={link} color={'#9c27b0'} border={'2px solid #9c27b0'}
                boxSizing={'border-box'} mt={5} p={3} borderRadius={'5px'}
                boxShadow={'0px 0px 12px 4px rgba(168,168,168,0.83)'} height={100} width={'100%'}>
        <Box component={"h3"} color={'primary'}>{title}</Box>
        <Box component={"h2"}>
            <StyledDeletedPrice component={'span'} color={'disabledColor'}>{orgAmount}</StyledDeletedPrice>{amount}
        </Box>
    </Box>
}